const SITEMAP = [
  { title: "快速入口", links: ["最新猛料", "人物时间线", "事件合集索引", "按年总览", "深扒档案"] },
  { title: "归档维度", links: ["人物档案", "题材合集", "年份编年", "事件时间线", "更新记录"] },
  { title: "其他", links: ["关于本站", "投稿线索", "纠错通道", "内容声明", "联系小编"] },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200/70 bg-background-100/80">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid gap-8 md:grid-cols-[1.2fr_2fr]">
          <div>
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-600 text-background-50">
                <i className="ri-fire-fill text-base leading-none"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">国产黑料</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
              按人物与时间线归档的事件合集与深扒档案，专为想吃完整历史瓜、补全旧料的人而做。新料旧账，一次翻全。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["事件合集", "人物梳理", "最新猛料"].map((k) => (
                <span key={k} className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
                  #{k}
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 sm:grid-cols-3">
            {SITEMAP.map((col) => (
              <div key={col.title}>
                <h5 className="text-sm font-bold text-foreground-950">{col.title}</h5>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l}>
                      <a href="#top" className="whitespace-nowrap text-[13px] text-foreground-500 transition-colors hover:text-primary-700">
                        {l}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 rounded-lg border border-background-200/80 bg-background-50 p-5">
          <p className="flex items-center gap-2 text-xs font-semibold text-foreground-800">
            <i className="ri-information-line text-base text-accent-700"></i>
            内容提示
          </p>
          <p className="mt-2 text-xs leading-6 text-foreground-500">
            本站为专题合集浏览演示模板，页内涉及的人物代号与事件均为虚构示例，仅用于展示「按人物、事件、年份归档」的浏览结构与版式，不代表任何真实个体与事实，也不对任何真实人物作负面评价。如与真实情况雷同，纯属巧合。请理性看待网络信息，不信谣、不传谣。
          </p>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-background-200/70 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 国产黑料 · 专题合集档案演示页
          </p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-400">
            <i className="ri-focus-3-line"></i>
            干净轻壳 · 克制线条 · 持续归档中
          </p>
        </div>
      </div>
    </footer>
  );
}